export default __webpack_public_path__ + "static/media/target_markets_left.91ff8f55.svg";